import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Transition as _Transition } from "vue"

const _hoisted_1 = {
  id: "pg-email-builder-template-setting",
  class: "fixed inset-0 overflow-hidden"
}
const _hoisted_2 = { class: "absolute inset-0 overflow-hidden" }
const _hoisted_3 = { class: "absolute inset-y-0 right-0 pl-10 max-w-full flex sm:pl-16" }
const _hoisted_4 = {
  key: 0,
  class: "w-screen max-w-lg"
}
const _hoisted_5 = { class: "h-full flex flex-col bg-white shadow-xl overflow-y-scroll" }
const _hoisted_6 = { class: "flex-1" }
const _hoisted_7 = { class: "px-4 py-6 sm:px-6 border-b border-gray-200" }
const _hoisted_8 = { class: "flex items-start justify-between space-x-3" }
const _hoisted_9 = { class: "space-y-1" }
const _hoisted_10 = { class: "text-2xl leading-7 font-medium mb-2" }
const _hoisted_11 = { class: "text-sm text-gray-400 leading-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1 /* HOISTED */)
const _hoisted_13 = { class: "py-0 space-y-0" }
const _hoisted_14 = { class: "space-y-1 px-4 sm:space-y-0 sm:grid sm:grid-cols-1 sm:gap-5 padding-x-6 padding-y-5" }
const _hoisted_15 = {
  for: "from_name",
  class: "block text-sm font-medium leading-5 text-gray-500 sm:mt-px sm:pt-2"
}
const _hoisted_16 = { class: "sm:col-span-2 mt-2" }
const _hoisted_17 = { class: "rounded-md shadow-sm" }
const _hoisted_18 = { class: "relative" }
const _hoisted_19 = { class: "space-y-1 px-4 sm:space-y-0 sm:grid sm:grid-cols-1 sm:gap-5 padding-x-6 padding-y-5" }
const _hoisted_20 = {
  for: "from_email",
  class: "block text-sm font-medium leading-5 text-gray-500 sm:mt-px sm:pt-2"
}
const _hoisted_21 = { class: "sm:col-span-2 mt-2" }
const _hoisted_22 = { class: "rounded-md shadow-sm" }
const _hoisted_23 = { class: "relative" }
const _hoisted_24 = { class: "space-y-1 px-4 sm:space-y-0 sm:grid sm:grid-cols-1 sm:gap-4 padding-x-6 padding-y-5" }
const _hoisted_25 = {
  for: "project_description",
  class: "block text-sm font-medium leading-5 text-gray-500 sm:mt-px sm:pt-2"
}
const _hoisted_26 = { class: "sm:col-span-2" }
const _hoisted_27 = { class: "flex rounded shadow-sm" }
const _hoisted_28 = { class: "relative w-full" }
const _hoisted_29 = { class: "space-y-1 px-4 sm:space-y-0 sm:grid sm:grid-cols-1 sm:gap-5 padding-x-6 padding-y-5" }
const _hoisted_30 = {
  for: "preview_text",
  class: "block text-sm font-medium leading-5 text-gray-500 sm:mt-px sm:pt-2"
}
const _hoisted_31 = { class: "sm:col-span-2 mt-2" }
const _hoisted_32 = { class: "rounded-md shadow-sm" }
const _hoisted_33 = { class: "relative" }
const _hoisted_34 = { class: "flex-shrink-0 px-4 bg-gray-50 py-6 sm:px-6" }
const _hoisted_35 = { class: "space-x-3 flex justify-end" }
const _hoisted_36 = { class: "inline-flex rounded-md shadow-sm" }
const _hoisted_37 = { class: "inline-flex rounded-md shadow-sm" }

import { ref, watchEffect, PropType, computed } from 'vue'
import { UIInput, UIButton } from '@gohighlevel/ghl-ui'
import { useValidation } from '../../../common/composable/validation'

import { ICustomField, ICustomValue, Menu } from '../types'
import { hasHandleBar, isValidHandleBars } from '../../../common/utils/helper'

import CustomVariablePicker from '../../../common/components/CustomVariablePicker.vue'
import { useService } from '../service'
import { ActionTypes } from '../store/actions'
import { useStore } from '../store'
import i18n from 'common/locales'
import { useNotificationEvent } from 'common/composition/useNotificationEvent'


export default /*#__PURE__*/_defineComponent({
  __name: 'SaveTemplateSettings',
  props: {
  show: {
    type: Boolean,
    default: false,
  },

  userId: { type: String, required: true },
  templateId: { type: String, required: true },
  locationId: { type: String, required: true },
  customFieldsLocation: {
    type: Array as PropType<Array<ICustomField>>,
    default: [],
  },
  customValuesLocation: {
    type: Array as PropType<Array<ICustomValue>>,
    default: [],
  },
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit
const templateData = computed(() => store.state.templateData)
const store = useStore()
const showContent = ref(false)
const fromName = ref<string>(templateData.value?.fromName as string)
const fromEmail = ref<string>(templateData.value?.fromAddress as string)
const previewText = ref<string>(templateData.value?.previewText as string)
const emailSubject = ref<string>(templateData.value?.subjectLine as string)
const sendEmailLoader = ref(false)
const { validateEmail } = useValidation()
const service = useService()
const { enableNotification } = useNotificationEvent()

function onClickClose() {
  const pickerEl = document.querySelector('.dropdown-tree__container')
  if (pickerEl) return
  showContent.value = false
  setTimeout(() => {
    emit('close')
  }, 500)
}
watchEffect(() => {
  showContent.value = props.show
})

async function onClickSave() {
  sendEmailLoader.value = true
  try {
    const { data: newTemplateData } = await service.updateTemplate(
      props.templateId,
      {
        fromName: fromName.value,
        subjectLine: emailSubject.value,
        fromAddress: fromEmail.value,
        previewText: previewText.value,
        locationId: props.locationId,
        updatedBy: props.userId,
      }
    )
    store.dispatch(ActionTypes.UPDATE_TEMPLATE, newTemplateData)
    enableNotification({
      title: i18n.global.t('emailTemplate.settingsSaved'),
      content: i18n.global.t('emailTemplate.settingsSavedHelper'),
      type: 'success',
    })
    onClickClose()
  } catch (error: any) {
    enableNotification({
      title: i18n.global.t('common.somethingWentWrong'),
      content: i18n.global.t(`common.failedToSaveSettingsHelper`),
      type: 'error',
    })
  } finally {
    sendEmailLoader.value = false
  }
}

function updateFromEmail(payload: Menu) {
  if (payload.value) fromEmail.value = payload.value
}

function updateSubject(payload: Menu) {
  if (payload.value) emailSubject.value = payload.value
}

function updateFromName(payload: Menu) {
  if (payload.value) fromName.value = payload.value
}
function updatePreviewText(payload: Menu) {
  if (payload.value) previewText.value = payload.value
}
const isValidInput = computed(() => true)

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createVNode(_Transition, {
          "enter-active-class": "transform transition ease-in-out duration-500 sm:duration-700",
          "enter-class": "translate-x-full",
          "enter-to-class": "translate-x-0",
          "leave-active-class": "transform transition ease-in-out duration-500 sm:duration-700",
          "leave-class": "translate-x-0",
          "leave-to-class": "translate-x-full"
        }, {
          default: _withCtx(() => [
            (showContent.value)
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createCommentVNode(" Header "),
                      _createElementVNode("header", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.$t('emailTemplate.settingHeading')), 1 /* TEXT */),
                            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('emailTemplate.settingHeadingHelper')), 1 /* TEXT */)
                          ]),
                          _createElementVNode("div", { class: "h-7 flex items-center" }, [
                            _createElementVNode("button", {
                              onClick: onClickClose,
                              "aria-label": "Close panel",
                              class: "text-gray-400 hover:text-gray-500 transition ease-in-out duration-150"
                            }, [
                              _createCommentVNode(" Heroicon name: x "),
                              _hoisted_12
                            ])
                          ])
                        ])
                      ]),
                      _createCommentVNode(" Divider container "),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", null, [
                              _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('campaignSchedule.fromNameInput')), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("div", _hoisted_18, [
                                  _createVNode(_unref(UIInput), {
                                    id: "pg-email-builder-template-setting-from-email",
                                    name: "from_name",
                                    modelValue: fromName.value,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fromName).value = $event)),
                                    placeholder: _ctx.$t('common.name'),
                                    class: "pr-9 text-gray-400"
                                  }, null, 8 /* PROPS */, ["modelValue", "placeholder"]),
                                  _createVNode(CustomVariablePicker, {
                                    id: "__template-setting-from-name",
                                    "onUpdate:selectedValue": updateFromName,
                                    noMarginTop: true,
                                    customFieldsLocation: __props.customFieldsLocation,
                                    customValuesLocation: __props.customValuesLocation
                                  }, null, 8 /* PROPS */, ["customFieldsLocation", "customValuesLocation"])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createCommentVNode(" Project name "),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", null, [
                              _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('campaignSchedule.fromEmailInput')), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, [
                                  _createVNode(_unref(UIInput), {
                                    id: "pg-email-builder-template-setting-from-email",
                                    name: "from_email",
                                    modelValue: fromEmail.value,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fromEmail).value = $event)),
                                    placeholder: "example@mail.com",
                                    error: 
                                fromEmail.value
                                  ? !(
                                      _unref(validateEmail)(fromEmail.value) ||
                                      (_unref(hasHandleBar)(fromEmail.value) &&
                                        _unref(isValidHandleBars)(fromEmail.value))
                                    )
                                  : false
                              
                                  }, null, 8 /* PROPS */, ["modelValue", "error"]),
                                  _createVNode(CustomVariablePicker, {
                                    id: "__template-setting-from-email",
                                    "onUpdate:selectedValue": updateFromEmail,
                                    noMarginTop: true,
                                    customFieldsLocation: __props.customFieldsLocation,
                                    customValuesLocation: __props.customValuesLocation
                                  }, null, 8 /* PROPS */, ["customFieldsLocation", "customValuesLocation"])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", null, [
                            _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('common.emailSubject')), 1 /* TEXT */)
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("div", _hoisted_28, [
                                _createVNode(_unref(UIInput), {
                                  type: "textarea",
                                  placeholder: _ctx.$t('common.subject'),
                                  modelValue: emailSubject.value,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((emailSubject).value = $event)),
                                  id: "email_subject_line",
                                  rows: 3
                                }, null, 8 /* PROPS */, ["placeholder", "modelValue"]),
                                _createVNode(CustomVariablePicker, {
                                  id: "__template-setting-email-subject",
                                  class: "items-start -top-10",
                                  "onUpdate:selectedValue": updateSubject,
                                  noMarginTop: true,
                                  customFieldsLocation: __props.customFieldsLocation,
                                  customValuesLocation: __props.customValuesLocation
                                }, null, 8 /* PROPS */, ["customFieldsLocation", "customValuesLocation"])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", null, [
                              _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t('campaignSchedule.previewText')), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("div", _hoisted_33, [
                                  _createVNode(_unref(UIInput), {
                                    id: "pg-email-builder-template-setting-preview-text",
                                    name: "preview_text",
                                    placeholder: _ctx.$t('campaignSchedule.previewText'),
                                    modelValue: previewText.value,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((previewText).value = $event))
                                  }, null, 8 /* PROPS */, ["placeholder", "modelValue"]),
                                  _createVNode(CustomVariablePicker, {
                                    id: "__template-setting-preview-text",
                                    "onUpdate:selectedValue": updatePreviewText,
                                    noMarginTop: true,
                                    customFieldsLocation: __props.customFieldsLocation,
                                    customValuesLocation: __props.customValuesLocation
                                  }, null, 8 /* PROPS */, ["customFieldsLocation", "customValuesLocation"])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createCommentVNode(" Action buttons "),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("span", _hoisted_36, [
                          _createVNode(_unref(UIButton), {
                            id: "pg-email-builder-template-setting-cancel-btn",
                            onClick: onClickClose,
                            size: "large"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _createElementVNode("span", _hoisted_37, [
                          _createVNode(_unref(UIButton), {
                            id: "pg-email-builder-template-setting-save-btn",
                            onClick: onClickSave,
                            class: _normalizeClass({
                        'cursor-not-allowed': !isValidInput.value,
                        'bg-curious-blue-500 text-white hover:bg-curious-blue-400':
                          isValidInput.value,
                        'pointer-events-none': sendEmailLoader.value,
                      }),
                            type: "primary",
                            disabled: !isValidInput.value,
                            loading: sendEmailLoader.value,
                            size: "large"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["class", "disabled", "loading"])
                        ])
                      ])
                    ])
                  ])
                ])), [
                  [_directive_click_outside, showContent.value && onClickClose]
                ])
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        })
      ])
    ])
  ]))
}
}

})